import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  extractData,
  extractCalculateTarrifType,
  extractCalculateTarrifHeading,
  getHeadingsByTypes,
  filterTariffsByType,
} from '../../api/Requests';
import {
  REACT_APP_TARIFFTYPES,
  getDefaultTariffTypes,
  getBlacklistedTariffs,
  stripDisabledTariffTypes,
} from 'src/utils/constants';
import axios from 'axios';
import { RootState } from '..';
import allMandants from '../../config/mandant';
import { getTariffAdditionalBody, resolveMandant } from 'src/utils';

export const calculateTariffsAdditional = createAsyncThunk(
  'calculate/tariffs/additional',
  async (props: any, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const queryParams = new URLSearchParams(window.location.search);
      const tariffs = queryParams.get('tariffs') || '';
      const tariffsArray = tariffs.replace(/@/g, '#').split(',');
      const insurers = queryParams.get('insurers') || '';
      const insurersArray = insurers.split(',');
      const tarifftypes = queryParams.get('tarifftypes') || '';

      const defaultMandant = process.env.REACT_APP_MANDANT_DEFAULT as string;
      const mandant = resolveMandant(defaultMandant);
      const allTariffs = getDefaultTariffTypes(mandant);

      // Filter based on selected tariffs from Redux
      const selectedTariffs = state.contribution.selectedTariffs;
      const tariffsToProcess = stripDisabledTariffTypes(
        selectedTariffs.length > 0
          ? selectedTariffs
          : tarifftypes
          ? tarifftypes.split(',')
          : allTariffs
      );

      const obje = extractCalculateTarrifType(
        tariffsToProcess.join(','),
        state.contribution.homecareLevel5Inpatient,
        state.contribution.daySicknessDailyAllowance1,
        state.contribution.rateSicknessDailyAllowance1
      );

      const promises = obje.map((obj) =>
        axios.post(
          process.env.REACT_APP_BASE_URL +
            `/${state.config.mandant}/calculate/tariffs/additional`,
          {
            ...props.data,
            additional: getTariffAdditionalBody(obj, state.config.mandant),
          }
        )
      );
      const response = await Promise.all(promises);
      const insuraceType = await axios.get(
        process.env.REACT_APP_BASE_URL +
          `/${state.config.mandant}/calculate/insurances/additional`
      );

      const tariftypes = Object.fromEntries(
        REACT_APP_TARIFFTYPES.map((tariff) => [tariff.heading, tariff.type])
      );

      const heading = getHeadingsByTypes(tariffsToProcess);
      const responseFinal = extractCalculateTarrifHeading(heading);
      const ratings: any = {};
      const minPrice = allMandants[mandant]?.minPrice;
      const blacklistedTariffs = getBlacklistedTariffs(mandant);

      responseFinal.forEach((res, index) => {
        res.options = extractData(
          response[index],
          insuraceType?.data?.value,
          tariffsArray,
          insurersArray,
          tariftypes[res.title]
        );
        res.options = filterTariffsByType(
          tariftypes[res.title],
          res.options,
          (option) => option.tarrifId
        );
        res.options.forEach((option) => {
          ratings[option.tarrifId] = null;
        });

        if (minPrice !== null) {
          res.options = res.options.filter((option) => option.fee > minPrice);
        }
        if (blacklistedTariffs.length > 0) {
          res.options = res.options.filter(
            (option) => !blacklistedTariffs.includes(option.tarrifId)
          );
        }
      });

      const resObj = [
        {
          Id: props.Id,
          total: 0,
          birthdate: props?.data.customer?.birthday,
          gender: props?.data?.customer?.gender,
          res: responseFinal,
          ratings,
        } as InsuredPerson,
      ];

      return resObj;
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
);

export const getTariffsRating = createAsyncThunk<
  any,
  { mandant: string; tarrifId: string; personIdx: number },
  { state: RootState }
>('get/tariffs/ratings', async (props) => {
  try {
    const { mandant, tarrifId } = props;
    const response = await axios.get(
      process.env.REACT_APP_BASE_URL +
        `/${mandant}/optimize/tariff/additional/${tarrifId}`
    );

    return response?.data?.value?.templateOnlineQuestions;
  } catch (e) {
    console.error(e);
    throw e;
  }
});
